// <- shared style/theme types
// src/types/design.ts

export type Color =
  // Text on a navy surface (light mode) — IC Text v2 Dark values.
  | "on-navy"
  | "on-navy-secondary"
  | "on-navy-tertiary"
  | "success"
  | "warning"
  | "error"
  | "orange"
  | "white"
  | "blue"
  | "blue_grey"
  | "blue_grey1"
  | "blue_grey2"
  // POC parity — slate palette (popup heading/kicker/label/body).
  | "slate-900"
  | "slate-800"
  | "slate-700"
  | "slate-600"
  | "slate-500";

export type Weight = "normal" | "medium" | "semibold" | "bold";

export type TextAlign = 'left' | 'center' | 'right'| 'justify' | 'start' | 'end';

export type FontFamily = "bold" | "light" | "regular";

export type TextSize = "xs" | "sm" | "lg" | "xl" | "base" | "2xl";

export type BtnSize = "xm" | "sm" | "md" | "lg" | "xl";

export const fontClasses: Record<Weight, string> = {
  normal: "font-normal",
  medium: "font-medium",
  semibold: "font-semibold",
  bold: "font-bold",
};
export const alignClasses: Record<TextAlign, string> = {
  left: "text-left",
  center: "text-center",
  right: "text-right",
  justify: "text-justify",
  start: "text-start",
  end: "text-end",
};
// export const colorClasses: Record<Color, string> = {
// success: "text-success",
// warning: "text-warning",
// error: "text-error",
// orange: "text-orange",
// blue: "text-blue",
// blue_grey: "text-blue_grey",
// blue_grey1: "text-blue_grey1",
// blue_grey2: "text-blue_grey2"
// };

// IC type scale (.claude/skills/ic-ui/ic-typography.md): line-height is fixed
// per size and must travel with it. Bare Tailwind `text-*` carries Tailwind's
// own line-heights (text-sm = 20px where IC specifies 21px), so each step
// pairs its size with the IC value explicitly.
export const sizeClasses: Record<TextSize, string> = {
  xs: "text-[12px] leading-[18px]", // Small — helper/meta (Caption 11px is opt-in via .text-caption)
  sm: "text-[14px] leading-[21px]", // Body/Regular — default
  base: "text-[16px] leading-[24px]", // Body/Large
  lg: "text-[18px] leading-[27px]", // Header/H4
  xl: "text-[20px] leading-[30px]", // Header/H3
  "2xl": "text-[24px] leading-[32px]", // Header/H2
};
